export enum GradeEnum {
  Secondary1 = 'Secondary1',
  Secondary2 = 'Secondary2',
  Secondary3 = 'Secondary3'
}

export interface Book {
  id: string;
  title: string;
  description?: string;
  imagePath?: string;
  price: number;
  grade: GradeEnum;
  active: boolean;
  createdAt: string;
  modifiedAt: string;
}

export interface CreateBookRequest {
  title: string;
  description?: string;
  price: number;
  grade: GradeEnum;
  active?: boolean;
}

export interface CreateBookWithImageRequest extends CreateBookRequest {
  imageFile?: File;
}

export interface UpdateBookRequest {
  title: string;
  description?: string;
  imagePath?: string;
  price: number;
  grade: GradeEnum;
  active: boolean;
}

export interface UpdateBookWithImageRequest extends Omit<UpdateBookRequest, 'imagePath'> {
  imageFile?: File;
}

export interface BookFilters {
  title: string;
  grade: string;
  active: string;
  priceMin: string;
  priceMax: string;
}

export interface BookFormData {
  title: string;
  description: string;
  price: string;
  grade: string;
  active: boolean;
  imageFile?: File;
}

export interface PaginatedBooksResponse {
  books: Book[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface SortConfig {
  key: keyof Book | null;
  direction: 'asc' | 'desc';
}

export const GRADE_OPTIONS = [
  { value: GradeEnum.Secondary1, label: 'الثانوية الأولى' },
  { value: GradeEnum.Secondary2, label: 'الثانوية الثانية' },
  { value: GradeEnum.Secondary3, label: 'الثانوية الثالثة' }
];

export const GRADE_LABELS: Record<GradeEnum, string> = {
  [GradeEnum.Secondary1]: 'الثانوية الأولى',
  [GradeEnum.Secondary2]: 'الثانوية الثانية',
  [GradeEnum.Secondary3]: 'الثانوية الثالثة'
}; 